import { axios } from '../../lib'
import toast from 'react-hot-toast'
import TYPES from '../types'

const altMerchantLists = (data) => ({
  type: TYPES.ALT_MERCHANT_LISTS,
  data,
})

export const getAllMerchants = (page = 1, limit = 10, search = '') => async (dispatch) => {
  try {
    const queryParams = new URLSearchParams({ page, limit, search }).toString()
    const response = await axios.get(`/company/merchants?${queryParams}`)
    
    if (response && response.data) {
      const normalizedData = {
        data: response.data.map(merchant => ({
          id: merchant.id,
          companyName: merchant.companyName || merchant.company_name,
          email: merchant.email,
          phone: merchant.phone,
          address: merchant.address,
          contactPerson: merchant.contactPerson || merchant.contact_person,
          isActive: merchant.isActive !== undefined ? merchant.isActive : merchant.is_active,
          createdAt: merchant.createdAt || merchant.created_at,
          updatedAt: merchant.updatedAt || merchant.updated_at,
        })),
        pagination: response.pagination,
      }
      
      dispatch(altMerchantLists(normalizedData))
      return { success: true, data: normalizedData }
    }
  } catch (error) {
    console.error('Get merchants error:', error)
    toast.error(error.response?.data?.message || 'Failed to fetch merchants')
    return { success: false }
  }
}

export const checkMerchantEmail = async (email) => {
  try {
    const response = await axios.get(`/company/check-email/${encodeURIComponent(email)}`)
    return response.exists
  } catch (error) {
    console.error('Check email error:', error)
    return false
  }
}

export const createMerchant = (merchantData) => async (dispatch) => {
  try {
    const response = await axios.post('/company/merchants', merchantData)
    
    if (response && (response.status === 'success' || response.data)) {
      toast.success('Merchant created successfully')
      dispatch(getAllMerchants())
      return { success: true, data: response.data }
    }
  } catch (error) {
    console.error('Create merchant error:', error)
    const message = error.response?.data?.message || 'Failed to create merchant'
    toast.error(message)
    return { success: false, error: message }
  }
}

export const updateMerchant = (id, merchantData) => async (dispatch) => {
  try {
    const response = await axios.put(`/company/merchants/${id}`, merchantData)
    
    if (response && (response.status === 'success' || response.data)) {
      toast.success('Merchant updated successfully')
      dispatch(getAllMerchants())
      return { success: true, data: response.data }
    }
  } catch (error) {
    console.error('Update merchant error:', error)
    const message = error.response?.data?.message || 'Failed to update merchant'
    toast.error(message)
    return { success: false, error: message }
  }
}

export const toggleMerchantStatus = (id) => async (dispatch) => {
  try {
    const response = await axios.patch(`/company/merchants/${id}/status`)
    
    if (response && (response.status === 'success' || response.data)) {
      toast.success('Merchant status updated successfully')
      dispatch(getAllMerchants())
      return { success: true }
    }
  } catch (error) {
    console.error('Toggle merchant status error:', error)
    toast.error(error.response?.data?.message || 'Failed to update merchant status')
    return { success: false }
  }
}

export const deleteMerchant = (id) => async (dispatch) => {
  try {
    const response = await axios.delete(`/company/merchants/${id}`)
    
    if (response && (response.status === 'success' || response.data)) {
      toast.success('Merchant deleted successfully')
      dispatch(getAllMerchants())
      return { success: true }
    }
  } catch (error) {
    console.error('Delete merchant error:', error)
    toast.error(error.response?.data?.message || 'Failed to delete merchant')
    return { success: false }
  }
}

export const getMerchantStats = (id) => async (dispatch) => {
  try {
    const response = await axios.get(`/company/merchants/${id}/stats`)
    
    if (response && response.data) {
      return { 
        success: true, 
        data: {
          totalOrders: response.data.totalOrders || 0,
          pendingOrders: response.data.pendingOrders || 0,
          completedOrders: response.data.completedOrders || 0,
          totalRiders: response.data.totalRiders || 0,
          totalStaff: response.data.totalStaff || 0,
          totalRevenue: response.data.totalRevenue || 0,
        }
      }
    }
    return { success: false }
  } catch (error) {
    console.error('Get merchant stats error:', error)
    return { success: false, data: null }
  }
}
